var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuContacts = function SvgMenuContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16h8v-1c0-1.33-2.665-2-4-2s-4 .67-4 2zm6.884-1.139c.08.073.106.12.114.139H9.002a.5.5 0 0 1 .114-.139c.148-.136.4-.289.756-.431.713-.286 1.586-.43 2.129-.43s1.416.144 2.129.43c.355.142.608.295.755.431ZM12 12a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 12m1-2a1 1 0 1 1-1.999.001A1 1 0 0 1 13 10",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 20v-1.5h-.5a.5.5 0 0 1 0-1H4v-3h-.5a.5.5 0 0 1 0-1H4v-3h-.5a.5.5 0 0 1 0-1H4v-3h-.5a.5.5 0 0 1 0-1H4V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2M6 3h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1.5h.5a.5.5 0 0 0 0-1H5v-3h.5a.5.5 0 0 0 0-1H5v-3h.5a.5.5 0 0 0 0-1H5v-3h.5a.5.5 0 0 0 0-1H5V4a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgMenuContacts;